// extracted by mini-css-extract-plugin
export default {"MainLayout":"MainLayout_MainLayout__KmfH3","blocksSection":"MainLayout_blocksSection__m-K1t","blocksTitle":"MainLayout_blocksTitle__nvQ3+"};